var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-n5 mx-5"},[_vm._t("main")],2)}
var staticRenderFns = []

export { render, staticRenderFns }